import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.heading',
		defaultMessage: 'Operations',
		description: 'Section label',
	},
	shiftFromOpsgenieToJiraItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.shift-from-opsgenie-to-jira-item',
		defaultMessage: 'Move from Opsgenie to Jira',
		description: 'Sidebar option to shift from opsgenie to jira page.',
	},
	newLozenge: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.new-lozenge',
		defaultMessage: 'New',
		description: 'New lozenge for new features',
	},
	chatopsToolsItem: {
		id: 'navigation-apps-sidebar-nav4-sidebars-settings-global-products.operations-section.chatops-tools-item',
		defaultMessage: 'Chat and video tools',
		description: 'Sidebar option to open chatops tools page',
	},
});
